export default __webpack_public_path__ + "static/media/slider-dec.75585872.png";